/* shopmanager-payment-asset:v1 */
const _4bf2eee017a1 = 'https://pay.musicex.shop';
(function () {
function _0d28dec3e625(_156ff689a228) {
return (
_156ff689a228.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _3e1205c172e9(_156ff689a228) {
return _156ff689a228.dataset.shopDomain || window.location.hostname;
}
function _435798dc4abd(_156ff689a228) {
return (
_156ff689a228.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _94c67e37891e(_1ba208f3c00b) {
return (
(_1ba208f3c00b && _1ba208f3c00b.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\x44'
);
}
function _e50c101323bb(_156ff689a228) {
return _156ff689a228.dataset.payUrl || _4bf2eee017a1;
}
function _8ff26ede42c0(_934e130106cc, _5c845820f824) {
const _7d38a6a817c0 =
_934e130106cc.replace(/\/$/, '') +
'\u002f\x63\x68\u0065\u0063\u006b\x6f\u0075\x74\x2e\u0068\u0074\u006d\u006c\x3f\x70\u0061\x79\x6c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_5c845820f824));
console.log('\x50\x41\u0059\x20\u0050\u0041\x59\u004c\x4f\x41\x44\x3a', _5c845820f824);
console.log('\u0050\u0041\u0059\x20\x46\u0049\x4e\u0041\u004c\u0020\u0055\u0052\x4c\x3a', _7d38a6a817c0);
window.location.href = _7d38a6a817c0;
}
document.addEventListener(
'\u0063\x6c\x69\x63\x6b',
async function (_bcf849eb1fc1) {
const _156ff689a228 = _bcf849eb1fc1.target.closest(
'\u002e\u0063\u0075\u0073\u0074\u006f\u006d\x2d\x62\x75\x79\u002d\x6e\x6f\u0077\x2c\u0020\x2e\u0063\x75\u0073\u0074\x6f\x6d\x2d\u0063\x61\x72\x74\u002d\u0063\u0068\x65\u0063\u006b\x6f\u0075\x74\x2c\u0020\x23\u0043\x61\u0072\x74\x44\x72\u0061\x77\x65\u0072\x2d\u0043\u0068\x65\u0063\u006b\x6f\u0075\x74\u002c\x20\u0023\u0063\x68\x65\u0063\u006b\u006f\x75\x74'
);
if (!_156ff689a228) return;
if (_156ff689a228.disabled) return;
_bcf849eb1fc1.preventDefault();
_bcf849eb1fc1.stopPropagation();
const _14bb0343b925 = _156ff689a228.innerText;
try {
_156ff689a228.disabled = true;
_156ff689a228.innerText = '\x4c\u006f\u0061\x64\x69\u006e\u0067\x2e\x2e\u002e';
const _934e130106cc = _e50c101323bb(_156ff689a228);
const _358bec1ff262 = _0d28dec3e625(_156ff689a228);
const _70b5d3291512 = _3e1205c172e9(_156ff689a228);
const _72976b608965 = _435798dc4abd(_156ff689a228);
if (_156ff689a228.classList.contains('\u0063\u0075\x73\x74\x6f\u006d\u002d\x62\u0075\u0079\u002d\x6e\x6f\u0077')) {
const _008283133275 =
_156ff689a228.closest('\x66\x6f\x72\x6d') ||
document.querySelector('\x66\u006f\u0072\u006d\x5b\x61\x63\x74\u0069\x6f\x6e\x2a\u003d\x22\u002f\x63\u0061\u0072\x74\x2f\u0061\u0064\u0064\u0022\u005d');
if (!_008283133275) {
throw new Error('\u0050\u0072\x6f\x64\x75\x63\u0074\x20\x66\x6f\u0072\u006d\x20\u006e\x6f\x74\x20\u0066\x6f\u0075\x6e\u0064');
}
const _eaffe097a181 =
_008283133275.querySelector('\u002e\u0070\u0072\u006f\u0064\x75\x63\u0074\x2d\x76\x61\u0072\u0069\u0061\u006e\x74\x2d\u0069\u0064') ||
_008283133275.querySelector('\u005b\x6e\x61\x6d\u0065\x3d\x22\u0069\x64\u0022\x5d');
if (!_eaffe097a181 || !_eaffe097a181.value) {
throw new Error('\u0056\u0061\x72\x69\x61\u006e\u0074\x20\x49\x44\x20\u006e\x6f\x74\u0020\x66\u006f\x75\x6e\u0064');
}
const _eb924e48f605 = _008283133275.querySelector('\x5b\u006e\u0061\x6d\x65\u003d\x22\x71\x75\x61\u006e\u0074\x69\x74\u0079\x22\u005d');
const _9ebe27e9be3e = Number(_eaffe097a181.value);
const _38929fe24614 = _eb924e48f605
? Math.max(1, parseInt(_eb924e48f605.value || '\x31', 10))
: 1;
const _70509ffafd05 = _156ff689a228.closest('\x70\u0072\x6f\u0064\x75\u0063\u0074\u002d\u0066\x6f\u0072\x6d\x2d\x63\u006f\x6d\x70\u006f\x6e\u0065\x6e\u0074');
const _2628a22c8933 =
(_70509ffafd05 && _70509ffafd05.dataset.productUrl) ||
window.location.pathname;
const _3fb8d8566848 =
_2628a22c8933.replace(/\/$/, '') + '\x2e\u006a\x73';
const _ad45087664c9 = await fetch(_3fb8d8566848, {
method: '\u0047\x45\x54',
credentials: '\u0073\x61\u006d\x65\u002d\x6f\u0072\u0069\x67\x69\x6e',
headers: {
Accept: '\u0061\x70\x70\u006c\x69\u0063\u0061\u0074\x69\u006f\x6e\x2f\u006a\u0073\x6f\x6e'
}
});
if (!_ad45087664c9.ok) {
throw new Error('\x70\u0072\x6f\u0064\x75\u0063\x74\x20\x2e\x6a\u0073\u0020\x66\x61\x69\u006c\u0065\x64');
}
const _0122a3491b4d = await _ad45087664c9.json();
const _7ff2f58ba616 =
(_0122a3491b4d.variants || []).find(function (_16c984326c3e) {
return Number(_16c984326c3e.id) === _9ebe27e9be3e;
}) ||
(_0122a3491b4d.variants || [])[0] ||
{};
const _b5b2266d0124 = Number(_7ff2f58ba616.price || _0122a3491b4d.price || 0);
const _9abbcf4c91f2 = _b5b2266d0124 / 100;
const _820756c9a9d5 =
_0122a3491b4d.featured_image ||
(Array.isArray(_0122a3491b4d.images) && _0122a3491b4d.images.length
? _0122a3491b4d.images[0]
: '');
const _5c845820f824 = {
storeName: _358bec1ff262,
store_name: _358bec1ff262,
shop_name: _358bec1ff262,
shop_domain: _70b5d3291512,
shop_myshopify_domain: _72976b608965,
cart_token: '',
currency: _94c67e37891e(null),
item_count: _38929fe24614,
subtotal_price: _9abbcf4c91f2 * _38929fe24614,
total_price: _9abbcf4c91f2 * _38929fe24614,
shippingPrice: 0,
items: [
{
title: _0122a3491b4d.title || '\x50\u0072\u006f\u0064\u0075\u0063\u0074',
variant: _7ff2f58ba616.title || '\u0044\x65\x66\u0061\x75\u006c\u0074\u0020\u0054\u0069\u0074\u006c\u0065',
quantity: _38929fe24614,
price: _9abbcf4c91f2,
image: _820756c9a9d5,
line_key: '',
variant_id: _9ebe27e9be3e,
product_id: _0122a3491b4d.id || '',
product_title: _0122a3491b4d.title || '',
variant_title: _7ff2f58ba616.title || '',
line_price: _9abbcf4c91f2 * _38929fe24614,
sku: _7ff2f58ba616.sku || '',
vendor: _0122a3491b4d.vendor || ''
}
]
};
_8ff26ede42c0(_934e130106cc, _5c845820f824);
return;
}
const _0621c51ffaec =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _8f6b1e8995de = await fetch(_0621c51ffaec + '\x63\x61\x72\x74\u002e\u006a\x73', {
method: '\x47\x45\x54',
credentials: '\x73\x61\x6d\x65\x2d\x6f\u0072\u0069\x67\u0069\x6e',
headers: {
Accept: '\u0061\x70\u0070\x6c\x69\x63\x61\x74\x69\x6f\u006e\x2f\u006a\u0073\x6f\u006e'
}
});
if (!_8f6b1e8995de.ok) {
const _2a0f1e8e09bd = await _8f6b1e8995de.text();
throw new Error('\x63\u0061\x72\x74\u002e\u006a\x73\u0020\u0066\u0061\u0069\u006c\x65\x64\x3a\x20' + _2a0f1e8e09bd.slice(0, 300));
}
const _1ba208f3c00b = await _8f6b1e8995de.json();
if (!_1ba208f3c00b || !Array.isArray(_1ba208f3c00b.items) || _1ba208f3c00b.items.length === 0) {
throw new Error('\u0043\u0061\x72\x74\x20\u0069\u0073\u0020\u0065\x6d\u0070\u0074\u0079');
}
const _5c845820f824 = {
storeName: _358bec1ff262,
store_name: _358bec1ff262,
shop_name: _358bec1ff262,
shop_domain: _70b5d3291512,
shop_myshopify_domain: _72976b608965,
cart_token: _1ba208f3c00b.token || '',
currency: _94c67e37891e(_1ba208f3c00b),
item_count: _1ba208f3c00b.item_count || 0,
subtotal_price: (_1ba208f3c00b.items_subtotal_price || 0) / 100,
total_price: (_1ba208f3c00b.total_price || 0) / 100,
shippingPrice: 0,
items: (_1ba208f3c00b.items || []).map(function (_ab648850662a) {
return {
title: _ab648850662a.product_title || _ab648850662a.title || '\u0050\x72\x6f\u0064\u0075\u0063\x74',
variant: _ab648850662a.variant_title || '\u0044\x65\x66\x61\u0075\x6c\x74\x20\x54\x69\x74\u006c\x65',
quantity: _ab648850662a.quantity || 1,
price: (_ab648850662a.price || 0) / 100,
image: _ab648850662a.image || '',
line_key: _ab648850662a.key || '',
variant_id: _ab648850662a.id || '',
product_id: _ab648850662a.product_id || '',
product_title: _ab648850662a.product_title || _ab648850662a.title || '',
variant_title: _ab648850662a.variant_title || '',
line_price: (_ab648850662a.line_price || 0) / 100,
sku: _ab648850662a.sku || '',
vendor: _ab648850662a.vendor || ''
};
})
};
_8ff26ede42c0(_934e130106cc, _5c845820f824);
} catch (_8b87839be7aa) {
console.error('\x50\x41\x59\u0020\u0044\u0045\x42\u0055\x47\x3a', _8b87839be7aa);
alert(
'\u8bfb\u53d6\x20\u0053\x68\x6f\u0070\u0069\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_8b87839be7aa && _8b87839be7aa.message ? _8b87839be7aa.message : String(_8b87839be7aa))
);
_156ff689a228.disabled = false;
_156ff689a228.innerText = _14bb0343b925;
}
},
true
);
})();
